import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled/macro';
import Tooltip from '../common/Tooltip';
import { toggleCommentsSidebar } from '../../store/ui/uiActions';
import { fetchRecentComments } from '../../store/api';
import { receiveRecentComments } from '../../store/comments/commentsActions';
import { getUnreadRecentCount } from '../../store/comments/commentsSelectors';
import CommentIcon from '../comments/CommentIcon';

const StyledButton = styled.button`
  height: 2rem;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const IconWrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-observations);
  color: var(--color-dark);
  font-weight: bold;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  font-size: 0.6rem;
  line-height: 1;
  border: 2px solid var(--surface-1, #2d2f3c);
  pointer-events: none;
`;

const CommentsSidebarButton = () => {
  const dispatch = useDispatch();
  const unread = useSelector(getUnreadRecentCount);
  const open = useSelector((state) => state.ui.uiCommentsSidebarOpen);

  useEffect(() => {
    let cancelled = false;
    fetchRecentComments({ days: 7, limit: 100 })
      .then(({ response }) => {
        if (cancelled || !response) return;
        dispatch(receiveRecentComments({ comments: response.comments || [] }));
      })
      .catch(() => { });
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return (
    <StyledButton
      data-comments-toggle="true"
      onClick={() => dispatch(toggleCommentsSidebar(!open))}
    >
      <Tooltip message="Observation Messages">
        <IconWrap>
          <CommentIcon width="1.5rem" height="1.5rem" color="white" />
          {unread > 0 && <Badge>{unread > 99 ? '99+' : unread}</Badge>}
        </IconWrap>
      </Tooltip>
    </StyledButton>
  );
};

export default CommentsSidebarButton;
